import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";

const getDashboardData = {
    namespaced: true,
    state: {
        headersEndingProject: [],
        headersPendingInvoices: [],
        headersPendingOffers: [],
        headersLastProjectReportEntries: [],

        pendingInvoicesData: [],
        pendingOffersData: [],
        endingProjectsData: [],
        lastProjectReportEntriesData: [],

        topSection: {},

        yearIncome: null,

        headersLoaded: false,
        dataLoading: false,
        dataLoaded: false,
    },
    mutations: {
        GET_HEADERS_SUCCESS(state, response) {
            response.data.pendingInvoices.forEach(el => el.class = "table-headers");
            response.data.pendingOffers.forEach(el => el.class = "table-headers");
            response.data.endingProjects.forEach(el => el.class = "table-headers");
            response.data.lastProjectReportEntries.forEach(el => el.class = "table-headers");

            state.headersLoaded = true;
            state.headersEndingProject = response.data.endingProjects;
            state.headersPendingInvoices = response.data.pendingInvoices;
            state.headersPendingOffers = response.data.pendingOffers;
            state.headersLastProjectReportEntries = response.data.lastProjectReportEntries;
        },
        GET_HEADERS_FAILURE(state, error) {
            state.headersLoaded = false;
            console.log(error);
        },
        GET_DASHBOARD_DATA_SUCCESS(state, response) {  
            state.endingProjectsData = response.data.data.endingProjects;
            state.pendingInvoicesData = response.data.data.pendingInvoices;
            state.pendingOffersData = response.data.data.pendingOffers;
            state.lastProjectReportEntriesData = response.data.data.lastProjectReportEntries;

            state.topSection = response.data.data.topSection;

            state.yearIncome = response.data.data.yearIncome;
            state.dataLoaded = true;
        },
        GET_DASHBOARD_DATA_FAILURE(state, error) {
            console.log(error);
        },
        RESET_DATA_LOADED(state) {
            state.dataLoaded = false;
        }
    },
    actions: {
        getHeaders: function({ dispatch }) {
            let url = "/dashboard/tableHeaders/gedDashboardTableHeaders";
            let promise = sendRequest("get", config.baseURLApi + url);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetHeadersInvoices", result[1]);
                } else {
                    dispatch("failureGetHeadersInvoices", result[1]);
                }
            });
        },
        successGetHeadersInvoices: function({ commit }, response) {
            commit("GET_HEADERS_SUCCESS", response);
        },
        failureGetHeadersInvoices: function({ commit }, error) {
            commit("GET_HEADERS_FAILURE", error);
        },
        
        getDashboardRequest: function({ dispatch, state }) {
            let dashboardUrl = config.baseURLApi+"/dashboard";

            let promise = sendRequest("get", dashboardUrl, {}, {}, true);
            state.dataLoading = true;
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetDashboardData", result[1]);
                } else {
                    dispatch("failureGetDashboardData", result[1]);
                }
                state.dataLoading = false;
            })
        },
        successGetDashboardData: function({ commit }, response) {
            commit("GET_DASHBOARD_DATA_SUCCESS", response);
        },
        failureGetDashboardData: function({ commit }, error) {
            commit("GET_DASHBOARD_DATA_FAILURE", error);
        },
        resetDataLoaded({commit}) {
            commit("RESET_DATA_LOADED");
        }
    }
}

export default getDashboardData;